import { render, staticRenderFns } from "./imgDraw.vue?vue&type=template&id=f590011c&scoped=true"
import script from "./imgDraw.vue?vue&type=script&lang=js"
export * from "./imgDraw.vue?vue&type=script&lang=js"
import style0 from "./imgDraw.vue?vue&type=style&index=0&id=f590011c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f590011c",
  null
  
)

export default component.exports